var _style, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisitHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-women-day",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-women-day:not(.animated) .animable {opacity: 0;}svg#freepik_stories-women-day.animated #freepik--Calendar--inject-67 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}            @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }        .animator-hidden { display: none; }")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-67",
    className: "animable",
    style: {
      transformOrigin: "250px 226.87px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "250px 382.525px"
    },
    id: "ellf6owhl7wb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.83,
    y: 398.49,
    width: 53.07,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "423.365px 398.615px"
    },
    id: "elps8jrd6aubp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.56,
    y: 395.36,
    width: 58.66,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "301.89px 395.485px"
    },
    id: "elst7ppbww6k7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.2,
    y: 393.92,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "389.795px 394.045px"
    },
    id: "ellycmuxtjice",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.47,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "122.065px 391.015px"
    },
    id: "elqi1v5dnmgxg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.46,
    y: 390.89,
    width: 15.44,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "87.18px 391.015px"
    },
    id: "eldj2qtn7vlxm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 54.2,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "158.57px 395.235px"
    },
    id: "el7g65rwm3aa8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "140.46px 196.4px"
    },
    id: "el8l08d6j2pcl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "356.75px 196.4px"
    },
    id: "el2wqgbeg5f06",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elqdbhk6z9tjb"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.5,
    y: 84.73,
    width: 97.17,
    height: 124.47,
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "143.085px 146.965px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elmomdcek189"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elxx6yiy83zan"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.26,
    y: 84.73,
    width: 101.41,
    height: 124.47,
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "139.965px 146.965px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "el2sotp0wqibb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el3iq1at88ik6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82.42,
    y: 100.94,
    width: 115.11,
    height: 92.05,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "139.975px 146.965px",
      transform: "rotate(90deg)"
    },
    className: "animable",
    id: "el825y1vf5ek7"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "141.28 204.52 122.78 89.41 107.39 89.41 125.88 204.52 141.28 204.52",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "124.335px 146.965px"
    },
    id: "elgdsd15iswig",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.17 204.52 135.68 89.41 128.94 89.41 147.44 204.52 154.17 204.52",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "141.555px 146.965px"
    },
    id: "elspxkusc9esk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ela2w1ugvr3se"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.68,
    y: 146.68,
    width: 115.11,
    height: 0.57,
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "94.235px 146.965px",
      transform: "rotate(90deg)"
    },
    className: "animable",
    id: "el9udw3mnzs7s"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ell24ut7192y9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 280.29,
    y: 84.18,
    width: 155.62,
    height: 132.46,
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "358.1px 150.41px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elalw7v8b1pn"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el9mlmr4p99b"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 275.21,
    y: 84.18,
    width: 158.33,
    height: 132.46,
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "354.375px 150.41px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elcpd4lzxvv6b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el6zvey0emlnt"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 280.29,
    y: 216.64,
    width: 155.62,
    height: 9.44,
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "358.1px 221.36px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elh1wa155tt7l"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elc1u1dfhoizv"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 266.75,
    y: 216.64,
    width: 158.33,
    height: 9.44,
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "345.915px 221.36px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elzd7c8wl09wc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el854r6p510tb"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 295.26,
    y: 78.36,
    width: 118.24,
    height: 144.11,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "354.38px 150.415px",
      transform: "rotate(90deg)"
    },
    className: "animable",
    id: "el57q04o0kdai"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "334.69 209.53 323.3 91.3 303.6 91.3 314.99 209.53 334.69 209.53",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "319.145px 150.415px"
    },
    id: "el61054sr9w88",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.14,169.45a.54.54,0,0,0,.54-.54v-73a.54.54,0,0,0-1.08,0v73A.54.54,0,0,0,423.14,169.45Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "423.14px 132.41px"
    },
    id: "elicuiak4p0y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.76 209.53 299.37 91.3 291.69 91.3 303.08 209.53 310.76 209.53",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "301.225px 150.415px"
    },
    id: "elgv1owurw6pf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el8xqz9oeg5u7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 223.66,
    y: 149.96,
    width: 118.24,
    height: 0.9,
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "282.78px 150.41px",
      transform: "rotate(90deg)"
    },
    className: "animable",
    id: "el9zypaf2znx"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elp1ctqevtx5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "273.53 104.19 429.15 104.19 429.81 94.06 274.19 94.06 273.53 104.19",
    style: {
      fill: "rgb(224, 224, 224)",
      opacity: 0.5,
      transformOrigin: "351.67px 99.125px"
    },
    className: "animable",
    id: "elky2f8fzoff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el3slyszpmn1l"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "273.53 120.84 429.15 120.84 429.81 110.71 274.19 110.71 273.53 120.84",
    style: {
      fill: "rgb(224, 224, 224)",
      opacity: 0.5,
      transformOrigin: "351.67px 115.775px"
    },
    className: "animable",
    id: "el4zu2uwo9ybg"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el9u8ol8545vf"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "273.53 137.49 429.15 137.49 429.81 127.36 274.19 127.36 273.53 137.49",
    style: {
      fill: "rgb(224, 224, 224)",
      opacity: 0.5,
      transformOrigin: "351.67px 132.425px"
    },
    className: "animable",
    id: "elyzbj8votjfm"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elv4u59f6c32l"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "273.53 154.14 429.15 154.14 429.81 144.01 274.19 144.01 273.53 154.14",
    style: {
      fill: "rgb(224, 224, 224)",
      opacity: 0.5,
      transformOrigin: "351.67px 149.075px"
    },
    className: "animable",
    id: "el8zhamadxdvq"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elu375swt8gxs"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "273.53 170.79 429.15 170.79 429.81 160.66 274.19 160.66 273.53 170.79",
    style: {
      fill: "rgb(224, 224, 224)",
      opacity: 0.5,
      transformOrigin: "351.67px 165.725px"
    },
    className: "animable",
    id: "elb8ua9w7xu2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el5apqlx20nle"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "273.53 187.44 429.15 187.44 429.81 177.31 274.19 177.31 273.53 187.44",
    style: {
      fill: "rgb(224, 224, 224)",
      opacity: 0.5,
      transformOrigin: "351.67px 182.375px"
    },
    className: "animable",
    id: "elqk803i7y73j"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M338.56,318.05a.94.94,0,0,0-.93-.75h-36a.94.94,0,0,0-.93.75L287.92,382.4h1.94l12.54-63.21h34.46L349.4,382.4h1.93Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "319.625px 349.85px"
    },
    id: "el654dzpnkrrh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.29,318.05a.94.94,0,0,0-.93-.75h-36a.94.94,0,0,0-.93.75L357.64,382.4h1.94l12.54-63.21h34.46l12.54,63.21h1.94Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "389.35px 349.85px"
    },
    id: "el9uyei6km825",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.31,310.1H296.05c-5.41,0-9.8,2.6-9.8,5.82v.2c0,1.17,1.6,2.12,3.58,2.12H415.54c2,0,3.57-.95,3.57-2.12v-.2C419.11,312.7,414.72,310.1,409.31,310.1Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "352.68px 314.17px"
    },
    id: "el13pabf654e5m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.25 263.43 341.36 263.43 330.5 307.65 405.39 307.65 416.25 263.43",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "373.375px 285.54px"
    },
    id: "el39gurvtlo36",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.39 307.65 405.09 310.1 330.2 310.1 330.5 307.65 405.39 307.65",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "367.795px 308.875px"
    },
    id: "elrfi88c8ep9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "413.94 263.43 339.05 263.43 328.2 307.65 403.09 307.65 413.94 263.43",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "371.07px 285.54px"
    },
    id: "elgfytf5d2pp6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.5 305.63 411.37 265.45 340.64 265.45 330.77 305.63 401.5 305.63",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "371.07px 285.54px"
    },
    id: "elrtlmyheexeg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.57 307.65 383.27 310.1 300.8 310.1 301.1 307.65 383.57 307.65",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "342.185px 308.875px"
    },
    id: "els9ls5mbv67",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.26,
    y: 316.78,
    width: 25.71,
    height: 5.7,
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "215.115px 319.63px"
    },
    id: "el60ymrox3sms",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elznr4x8a12kr"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.74,
    y: 251.33,
    width: 4.75,
    height: 131.07,
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "78.115px 316.865px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elwrsw662ns4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elcbsl7gj5fh4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.3,
    y: 316.78,
    width: 142.96,
    height: 5.7,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "130.78px 319.63px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "ell9rdvwltna"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 202.26,
    y: 347.95,
    width: 25.71,
    height: 5.7,
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "215.115px 350.8px"
    },
    id: "ele44riggwh5d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el8wps0cjim5b"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.3,
    y: 347.95,
    width: 142.96,
    height: 5.7,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "130.78px 350.8px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "el8472d8otwz7"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 202.26,
    y: 254.45,
    width: 25.71,
    height: 5.7,
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "215.115px 257.3px"
    },
    id: "el4bxnserwbru",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elxxrpux645pn"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.3,
    y: 254.45,
    width: 142.96,
    height: 5.7,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "130.78px 257.3px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "el8a66k81gedr"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 202.26,
    y: 285.61,
    width: 25.71,
    height: 5.7,
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "215.115px 288.46px"
    },
    id: "el7xpz7s1sgr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eltc14nfw0w8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.3,
    y: 285.61,
    width: 142.96,
    height: 5.7,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "130.78px 288.46px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "el1kwnzmpvtzw"
  })), /*#__PURE__*/React.createElement("g", {
    id: "els73j0toxbs"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 218.7,
    y: 251.33,
    width: 4.75,
    height: 131.07,
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "221.075px 316.865px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elq95soe6stor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el7qz582lte7g"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 197.51,
    y: 251.33,
    width: 4.75,
    height: 131.07,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "199.885px 316.865px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "eln0pzx5msy38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eltmz8gva09q"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.3,
    y: 251.33,
    width: 4.75,
    height: 131.07,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "61.675px 316.865px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elm0yda7rgp6h"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-67",
    className: "animable",
    style: {
      transformOrigin: "250px 416.24px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-67",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "250px 416.24px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Calendar--inject-67",
    className: "animable animator-active",
    style: {
      transformOrigin: "244.486px 217.457px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "elvg4ziw0mzo"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 130.57,
    y: 184.7,
    width: 16.82,
    height: 1,
    style: {
      fill: "current",
      transformOrigin: "138.98px 185.2px",
      transform: "rotate(-83.13deg)"
    },
    className: "animable",
    id: "elg9dcb9c17o8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el6l3x7sz2z2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 133.72,
    y: 202.28,
    width: 6.27,
    height: 1,
    style: {
      fill: "current",
      transformOrigin: "136.855px 202.78px",
      transform: "rotate(-83.12deg)"
    },
    className: "animable",
    id: "elu1n7pszl7ao"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M324.82,346.89,137.35,324.27a12.09,12.09,0,0,1-10.52-13.41l23.91-198.11a12.09,12.09,0,0,1,13.41-10.52l187.47,22.63a12.08,12.08,0,0,1,10.52,13.41l-23.91,198.1A12.08,12.08,0,0,1,324.82,346.89Z",
    style: {
      fill: "current",
      transformOrigin: "244.486px 224.561px"
    },
    id: "elabmby9l1o1c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el4k9prv67ss6"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 181.24,
    cy: 121.88,
    r: 13.13,
    style: {
      opacity: 0.3,
      transformOrigin: "181.24px 121.88px",
      transform: "rotate(-50.32deg)"
    },
    className: "animable",
    id: "el4ifjqhz4bm"
  })), /*#__PURE__*/React.createElement("g", {
    id: "els3l6sye2qz"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 330.35,
    cy: 139.88,
    r: 13.13,
    style: {
      opacity: 0.3,
      transformOrigin: "330.35px 139.88px"
    },
    className: "animable",
    id: "elicbchtmufbr"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el16lj1y3oco7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.11,144H319.86a7.78,7.78,0,0,1,7.78,7.78V340.61a7.78,7.78,0,0,1-7.78,7.78H156.11a0,0,0,0,1,0,0V144a0,0,0,0,1,0,0Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "241.875px 246.195px",
      transform: "rotate(96.88deg)"
    },
    className: "animable",
    id: "elt8a0fhuigxo"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M180.9,124.74h0a8.68,8.68,0,0,1-7.56-9.64l2.36-19.57A8.69,8.69,0,0,1,185.34,88h0a8.69,8.69,0,0,1,7.56,9.64l-2.36,19.56A8.7,8.7,0,0,1,180.9,124.74Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "183.119px 106.369px"
    },
    id: "el9iqlat3erg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330,142.73h0a8.69,8.69,0,0,1-7.56-9.64l2.36-19.56a8.69,8.69,0,0,1,9.64-7.56h0a8.68,8.68,0,0,1,7.56,9.64l-2.36,19.56A8.69,8.69,0,0,1,330,142.73Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "332.221px 124.35px"
    },
    id: "el9m1atmjv5k4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.91,310.28a92.31,92.31,0,0,1-25.16-3.46c-10.58-3-18.27-7.41-23.49-13.51-13.06-15.27-10.89-43.66-3.35-63.59C184.69,209.15,200,193.4,219,186.51c14.23-5.17,30.51-6.39,48.39-3.63,19.28,3,34.82,9.87,46.19,20.5a2.28,2.28,0,1,1-3.12,3.33c-10.68-10-25.41-16.49-43.77-19.32-17.11-2.64-32.63-1.5-46.13,3.4-17.72,6.44-32.07,21.21-39.39,40.55-5.91,15.61-10.11,44.21,2.55,59,4.62,5.4,11.58,9.35,21.27,12.09a90.65,90.65,0,0,0,50-.48c16.37-4.78,31.83-14,41.34-24.69,7-7.81,10.87-17.16,11-26.31.13-8.51-4.18-18.07-11.23-24.94-6-5.85-13-8.92-19.69-8.64a2.28,2.28,0,0,1-.19-4.56c8-.32,16.15,3.2,23.06,9.93,8,7.84,12.75,18.41,12.61,28.27-.15,10.25-4.47,20.65-12.16,29.28-10.06,11.3-26.3,21-43.46,26A97.85,97.85,0,0,1,228.91,310.28Z",
    style: {
      fill: "current",
      transformOrigin: "242.578px 245.862px"
    },
    id: "elqexhcjoxhmk",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-67",
    className: "animable animator-hidden",
    style: {
      transformOrigin: "262.753px 259.354px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(&quot",
      transformOrigin: "270.285px 265.054px"
    },
    id: "eljkfedfnxams",
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eliuspylcuvo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.2,160.29l-5.09-4.44-3.91,5.39.29,7.92L308.83,173c-1.86,1.56-3.71,3.11-5.58,4.64s-3.71,3.07-5.57,4.55c-.93.76-1.86,1.48-2.79,2.19s-1.87,1.38-2.69,1.91l-.6.36-.74.38c-.5.24-1,.52-1.5.74-1,.47-2.07.94-3.14,1.37-2.13.85-4.31,1.65-6.53,2.37-1.87.62-3.76,1.17-5.67,1.7l-.29-5.13a51,51,0,0,0-10.47,3.65c-.81-.16-1.66-.31-2.54-.45a1.18,1.18,0,0,0-.72-.38c-.43-.06-.83-.1-1.11-.12a1.15,1.15,0,0,0-.63.14l-1.12-.13a7.31,7.31,0,0,1-1.6-3.71,15.32,15.32,0,0,0,14.74-1.28,9.65,9.65,0,0,0,7.45-6.58,13.08,13.08,0,0,0-.84-10.54,13.51,13.51,0,0,0-12.07-20.27,11.66,11.66,0,0,0-1.69.16,10.32,10.32,0,0,0-13.62-2.17c.11-.13.2-.25.31-.37,2-2.2,5.17-3.21,8.84-2.83a.24.24,0,0,0,.26-.22.24.24,0,0,0-.22-.26c-3.82-.39-7.1.67-9.24,3a8.84,8.84,0,0,0-1,1.41c-.25,0-.5,0-.76,0a14.16,14.16,0,0,0-13.77,14.53,13.89,13.89,0,0,0,1.07,5,11.6,11.6,0,0,0-1.81,6.59,11.76,11.76,0,0,0,12.07,11.45,12.19,12.19,0,0,0,2.36-.3c-.05,2.57-1.14,4.8-4.93,5.5l.1-.35-2-.89a2.92,2.92,0,0,0-.29.23,52.33,52.33,0,0,0-8.62-8.44l-.94,1.75A111.7,111.7,0,0,1,226,169.31c-.17-.55-.38-1.25-.41-1.42s0-.35-.08-.53l0-.63a14.07,14.07,0,0,1,.38-3,42.82,42.82,0,0,1,2.17-6.61c.89-2.23,1.9-4.46,3-6.65s2.16-4.24,3.28-6.29a5.64,5.64,0,0,0,1.21-.59l5.45-3.65,2.73-5.23-6-3.09-4.37,5.75s-2.8,2.57-3,5.34a82.47,82.47,0,0,0-7.87,11.78,43.22,43.22,0,0,0-3.21,7.45,20.72,20.72,0,0,0-.91,4.41c0,.42,0,.83,0,1.26a12.56,12.56,0,0,0,.09,1.34,20.78,20.78,0,0,0,.46,2.24A93,93,0,0,0,223.8,186c.72,1.72,1.47,3.4,2.25,5.07l-3.2,6s2.22,7.84,4.81,11.72c.2,6.6.78,15.66,2,28.11h-.1c-.32,0-.58.13-.57.33l.11,2.89c0,.19.24.34.53.36h0c-1.19,7.91-6.9,46.8-7.79,68.43-.87,21.35,17.94,53.75,23.62,63l-1.28.59,2.4,3.34,2.28-.95,4.39,7.7-.8.64a1.72,1.72,0,0,0-.32.34,4.11,4.11,0,0,0-2.21-1.07,1.33,1.33,0,0,0-1,.4c-.38.36-.33.66-.22.85.25.45,1.18.69,2.12.78-1.08.32-2.28.8-2.52,1.37a.57.57,0,0,0,.06.59,1.05,1.05,0,0,0,.83.5,3,3,0,0,0,1.81-.82l.3-.26a37.66,37.66,0,0,1-6.39,10.31c-.9,1.1,1.35,3.51,3.89,1.48s7.85-6.6,9.73-8.11c3.06-2.44,4.34-3.24,6.8-5.13a1.28,1.28,0,0,0,.11-1.9l-5.2-4.87a.62.62,0,0,0-.73-.08l-2.6-4.52h0l-.73-1.26,2-.84-1.2-4.38-1.28.59c-3-9.19-16.3-49.41-14.25-60.4.1-.54.21-1.09.31-1.64v0c.8-4.3,1.65-8.92,2.51-13.63a103.53,103.53,0,0,0,4,14.36c3.19,8.6,40.67,24.63,50.62,28.76l-.95,1.67,4.17.88,1-1.69,7,3-.3.77a1.67,1.67,0,0,0-.11.44,4.75,4.75,0,0,0-2.55.43,1.49,1.49,0,0,0-.7.89c-.14.5.06.7.26.79a3.54,3.54,0,0,0,2.32-.61c-.8.86-1.63,1.92-1.54,2.5a.51.51,0,0,0,.37.42,1.21,1.21,0,0,0,1-.09,3.26,3.26,0,0,0,1.19-1.66c.05-.12.09-.25.13-.37.57,2.56.57,6.54-.25,11.62-.22,1.37,3.08,1.95,4.28-1.07s3.54-9.59,4.43-11.83c1.44-3.64,2.17-5,3.37-7.86a1.11,1.11,0,0,0-.91-1.53l-7.26-.81a.76.76,0,0,0-.77.46l-.09.23-4.41-1.9h0l-1.34-.58,1.4-2.26-3.52-2.91-.57,1c-7.91-6-27.49-20.24-34.37-25.05-2-1.37-3.64-3.06-3.92-5.43-2.62-22.31-3.75-45.68-4-51.62l.34,0c.37,0,.65-.19.55-.42l-.64-2.93a.57.57,0,0,0-.51-.27h0A112.72,112.72,0,0,1,265,214.34a61.39,61.39,0,0,0,10-5.35l-.42-7.43.63-.17c2.4-.69,4.78-1.48,7.16-2.32s4.71-1.81,7-2.89l1.74-.83,1.71-.91c.58-.29,1.14-.66,1.7-1l.85-.5.93-.64a38.07,38.07,0,0,0,3.09-2.51c.94-.84,1.87-1.68,2.76-2.53,1.81-1.7,3.54-3.44,5.25-5.2s3.37-3.54,5-5.33,3.28-3.62,4.86-5.5h0a10.8,10.8,0,0,0,2.31-5ZM249,383.57s-.09-.16.16-.41l.08-.07a1,1,0,0,1,.66-.21,3.77,3.77,0,0,1,2,1,2.88,2.88,0,0,0-.13.31C250.7,384.23,249.26,384,249,383.57Zm.2,3.05a.68.68,0,0,1-.55-.34.24.24,0,0,1,0-.23.92.92,0,0,1,.23-.28,9.25,9.25,0,0,1,2.79-1.09c0,.16-.08.33-.13.5C250.58,386.12,249.75,386.65,249.22,386.62ZM307,341.54s-.16-.08-.07-.4l0-.11a1.13,1.13,0,0,1,.48-.54,4.41,4.41,0,0,1,2.35-.37,1.55,1.55,0,0,0,0,.31C308.83,341.1,307.41,341.73,307,341.54Zm1.8,2.25a.78.78,0,0,1-.67,0,.19.19,0,0,1-.15-.17.78.78,0,0,1,.06-.34,10.28,10.28,0,0,1,1.93-2.44l.15.47A4.14,4.14,0,0,1,308.77,343.79Zm-31.5-164.73a9.21,9.21,0,0,1-6,6,15.41,15.41,0,0,0,5.88-12.53,15.23,15.23,0,0,0-.36-2.89A12.69,12.69,0,0,1,277.27,179.06Z",
    style: {
      opacity: 0.1,
      transformOrigin: "270.285px 265.054px"
    },
    className: "animable",
    id: "els2czzbxs07"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M215.47,190.63a123.35,123.35,0,0,1-6.7-14.59,96.72,96.72,0,0,1-4.67-15.47,19.85,19.85,0,0,1-.41-2.33,13,13,0,0,1-.06-1.39c0-.44.05-.86.08-1.29a21.49,21.49,0,0,1,1-4.53,45,45,0,0,1,3.53-7.61,86.06,86.06,0,0,1,9.34-13l3.33,2.47c-1.26,2.17-2.53,4.42-3.7,6.66S215,144,214,146.29a44,44,0,0,0-2.41,6.76,14.9,14.9,0,0,0-.49,3.1v.65c0,.18,0,.39.07.55s.22.9.38,1.48A119.66,119.66,0,0,0,216.46,173c1,2.32,2,4.62,3.07,6.92s2.2,4.59,3.29,6.74Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "213.225px 160.525px"
    },
    id: "el9v2ronbr0kh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.15,187.79c.59-7.35-12-17.35-12-17.35l-9.7,16.95s2.49,9.81,5.39,13.29S228.74,192.85,229.15,187.79Z",
    style: {
      fill: "current",
      transformOrigin: "218.31px 185.887px"
    },
    id: "elhg4pwjnfglj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elnju88fk00l"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "218.31px 185.887px"
    },
    className: "animable",
    id: "el7jxrqxgv0fd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.15,187.79c.59-7.35-12-17.35-12-17.35l-9.7,16.95s2.49,9.81,5.39,13.29S228.74,192.85,229.15,187.79Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "218.31px 185.887px"
    },
    id: "elt5xf4iya8k",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M222.09,132.52l5.73-3.61L220,126s-4,3.45-3.21,6.77l.77.26A5.29,5.29,0,0,0,222.09,132.52Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "222.253px 129.661px"
    },
    id: "eluv5zypats7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.78 123.59 224.66 120.22 220 126.04 227.82 128.91 230.78 123.59",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "225.39px 124.565px"
    },
    id: "el7xnmsbty98p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.2 378.19 234.52 381.16 226.28 365.73 233.17 361.47 242.2 378.19",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "234.24px 371.315px"
    },
    id: "elsq542kzp4hn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,380.43l7.33-5.55a.65.65,0,0,1,.86.05l5.23,5.17a1.31,1.31,0,0,1-.17,1.95c-2.59,1.89-3.93,2.68-7.15,5.12-2,1.5-7.53,6-10.27,8.1s-4.94-.52-4-1.63c4.28-5,6.74-9.23,7.36-12A2.22,2.22,0,0,1,233,380.43Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "235.693px 385.401px"
    },
    id: "eldet4o42n9z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el8m2udy6rdas"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "232.055px 367.365px"
    },
    className: "animable",
    id: "eljym1wziwadf"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "226.28 365.73 230.3 373.26 237.83 370.09 233.18 361.47 226.28 365.73",
    id: "el9yve7aax6to",
    className: "animable",
    style: {
      transformOrigin: "232.055px 367.365px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elgx6h23vvg9j"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 248.3,
    cy: 163.54,
    r: 15.97,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "248.3px 163.54px",
      transform: "rotate(-80.78deg)"
    },
    className: "animable",
    id: "elhim85836phn"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M256.58,177.1a.25.25,0,0,1,0-.5,9.44,9.44,0,0,0,7.63-6.3c1.52-4,1-8.88-1.33-11.66a.25.25,0,0,1,0-.35.26.26,0,0,1,.36,0c2.4,2.91,3,8,1.41,12.16a10,10,0,0,1-8,6.62Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "260.933px 167.659px"
    },
    id: "el65s4ef6zbig",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.06,181.37s-4,1-.49,49.57l33.12,2.95c.64-13.53,1.27-21.86,10.18-48.95a96.5,96.5,0,0,0-13.8-3.09,106.63,106.63,0,0,0-15-1.34C221.52,180.53,214.06,181.37,214.06,181.37Z",
    style: {
      fill: "current",
      transformOrigin: "234.499px 207.2px"
    },
    id: "el8p34xn4fsfn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el8c8xx0h0z66"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "234.499px 207.2px"
    },
    className: "animable",
    id: "el51fck6mr6vl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.06,181.37s-4,1-.49,49.57l33.12,2.95c.64-13.53,1.27-21.86,10.18-48.95a96.5,96.5,0,0,0-13.8-3.09,106.63,106.63,0,0,0-15-1.34C221.52,180.53,214.06,181.37,214.06,181.37Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "234.499px 207.2px"
    },
    id: "el8kzpwqf3yto",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 252.16,
    cy: 152.28,
    r: 13.97,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "252.16px 152.28px"
    },
    id: "elscpa5guaod",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241.94,
    cy: 144.97,
    r: 10.71,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "241.94px 144.97px"
    },
    id: "elu9l73zl1rer",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.19,143.21a.25.25,0,0,1-.25-.22,9.19,9.19,0,0,1,2.43-7.9c2.27-2.33,5.69-3.34,9.63-2.83a.25.25,0,0,1,.22.28.26.26,0,0,1-.28.22c-3.78-.49-7.05.46-9.21,2.68a8.72,8.72,0,0,0-2.3,7.48.25.25,0,0,1-.21.28Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "240.016px 137.67px"
    },
    id: "eljj0ij5f0wtn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.92,
    cy: 163.05,
    r: 12.15,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "230.92px 163.05px"
    },
    id: "el6c0ndzq6mrx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.48,
    cy: 151.09,
    r: 14.62,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "234.48px 151.09px"
    },
    id: "elnmv6jpml2en",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.09,164.79c-1.38,4.75-3.12,13.53,0,17.06,0,0-1.76,4.79-10.75,4-9.89-.88-4.29-5.33-4.29-5.33,5.51-.81,5.73-4.82,5.12-8.66Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "234.78px 175.364px"
    },
    id: "eld2oq6ptabou",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elhlxdjbv8na"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239,167.67l-5.88,4.17a15.74,15.74,0,0,1,.23,2.71c2.08-.11,5.12-2.12,5.53-4.26A7.4,7.4,0,0,0,239,167.67Z",
    style: {
      opacity: 0.2,
      transformOrigin: "236.092px 171.11px"
    },
    className: "animable",
    id: "elbaj0n8ssu18"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M250.56,160.13c-4.14,7-5.75,10-11.29,11.87-8.34,2.76-16-3.86-14.05-11.94,1.78-7.28,8.26-17.49,16.79-16.74A11.08,11.08,0,0,1,250.56,160.13Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "238.546px 157.959px"
    },
    id: "el3i42nag1nii",
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 251.58,
    cy: 154.85,
    rx: 8.07,
    ry: 11.56,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "251.58px 154.85px"
    },
    id: "eluanr1qy7jjq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.08,137.08c5.74,1.12,9.89,4.65,9.26,7.89s-5.79,5-11.54,3.86-9.89-4.65-9.26-7.89S237.33,136,243.08,137.08Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "241.94px 142.967px"
    },
    id: "elok7ncrauzg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.57,230.94s-8.5,47-10.18,71.91c-1.75,25.92,24.24,68.38,24.24,68.38l9.69-5.3c.2.15-16.37-51.92-13.62-64.72,5.84-27.2,14.12-68.11,14.12-68.11Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "220.563px 301.085px"
    },
    id: "elnfbkoj5xl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.2 367.95 227.09 372.65 224.7 369.13 238.09 363.4 239.2 367.95",
    style: {
      fill: "current",
      transformOrigin: "231.95px 368.025px"
    },
    id: "elz8e7u6ov49l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eluv03afj3mjf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.8,249.28c3.49-4.84,5.66-4.43,6.94-1.05-2.85,13.92-7.16,34.85-10.68,51.32C221.43,286.92,217,264.17,227.8,249.28Z",
    style: {
      opacity: 0.2,
      transformOrigin: "227.815px 272.609px"
    },
    className: "animable",
    id: "elfhew0ddc92"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "300.89 330.26 296.34 337.07 278.91 329.02 283.47 322.21 300.89 330.26",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "289.9px 329.64px"
    },
    id: "elyzqd5mi9jy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.45,336.67l3.62-8.46a.75.75,0,0,1,.8-.45l7.47,1a1.14,1.14,0,0,1,.9,1.61c-1.32,2.93-2.11,4.3-3.7,8-1,2.29-3.54,8.93-4.89,12.09s-4.72,2.4-4.46,1c1.19-6.28,1.12-11,.21-13.45A1.86,1.86,0,0,1,293.45,336.67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "299.76px 340.212px"
    },
    id: "elsvsbo7f6i9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eleumaqnixd46"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "285.69px 327.69px"
    },
    className: "animable",
    id: "el51rmx1ysmbc"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "278.92 329.02 287.9 333.17 292.46 326.36 283.48 322.21 278.92 329.02",
    id: "elbc8sqee9p49",
    className: "animable",
    style: {
      transformOrigin: "285.69px 327.69px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M222.73,231.76s-.15,44.82,8,68.72c3.52,10.34,53.95,32.17,53.95,32.17l7.14-8.46c.71.14-29.27-23.05-38.2-29.65-2-1.47-3.67-3.27-3.9-5.72-2.42-26.74-2.75-54.9-2.75-54.9Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "257.281px 282.205px"
    },
    id: "el6y1kwi19mtb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.6 323.43 285.47 334.29 281.19 333.26 289.05 320.32 292.6 323.43",
    style: {
      fill: "current",
      transformOrigin: "286.895px 327.305px"
    },
    id: "eltc6q7380x0q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.63,339.88a3.37,3.37,0,0,1-1.27,1.69,1.23,1.23,0,0,1-1.06.06.54.54,0,0,1-.37-.44c-.14-1.07,2.77-3.62,3.1-3.9a.2.2,0,0,1,.23,0,.17.17,0,0,1,.1.18A13.73,13.73,0,0,1,293.63,339.88Zm-2.22.88a.62.62,0,0,0-.07.35.2.2,0,0,0,.15.18.79.79,0,0,0,.69,0c.63-.33,1.23-1.55,1.66-3.3A12,12,0,0,0,291.41,340.76Z",
    style: {
      fill: "current",
      transformOrigin: "292.643px 339.488px"
    },
    id: "el0zfq6gx4hqk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.35,337.47l-.05.07c-.81.77-3.29,2.07-4.13,1.67-.2-.09-.4-.31-.24-.82a1.58,1.58,0,0,1,.75-.89c1.23-.71,3.45-.28,3.54-.27a.19.19,0,0,1,.14.13A.22.22,0,0,1,294.35,337.47Zm-4,.88a.76.76,0,0,0,0,.11c-.11.34,0,.4.06.42.51.23,2.37-.59,3.35-1.34a5.15,5.15,0,0,0-2.86.27A1.1,1.1,0,0,0,290.36,338.35Z",
    style: {
      fill: "current",
      transformOrigin: "292.117px 338.188px"
    },
    id: "el6n77u9wxesr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.57,156.93c-.3.59-.85.91-1.24.71s-.45-.83-.15-1.42.86-.91,1.24-.71S238.88,156.34,238.57,156.93Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "237.876px 156.575px"
    },
    id: "elhjcxqqirpy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.93,153.53c-.3.58-.86.9-1.24.7s-.45-.83-.15-1.42.86-.9,1.24-.7S232.23,152.94,231.93,153.53Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "231.235px 153.17px"
    },
    id: "el5stcxdzicy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.93,152.23l-1.2-1.14S230.89,152.57,231.93,152.23Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "231.33px 151.685px"
    },
    id: "elxwmnr9gfd2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.93,154.85a17.4,17.4,0,0,1-4,2.67,2.81,2.81,0,0,0,1.89,1.47Z",
    style: {
      fill: "rgb(237, 137, 62)",
      transformOrigin: "230.93px 156.92px"
    },
    id: "elai6di8o5oio",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.83,162.94a8.31,8.31,0,0,1-.9-.38.2.2,0,0,1-.08-.26.2.2,0,0,1,.26-.09,5.21,5.21,0,0,0,4.73.13.19.19,0,0,1,.19.33A5.43,5.43,0,0,1,232.83,162.94Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "234.477px 162.716px"
    },
    id: "el1bexuiklskg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.12,167.75a6,6,0,0,1-4.26,1.54c-2.08-.11-2.46-2.14-1.32-3.75,1-1.45,3.33-3.14,5.15-2.24A2.67,2.67,0,0,1,249.12,167.75Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "246.515px 166.171px"
    },
    id: "elr0fvcidhhtj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.43,156.16a.39.39,0,0,1-.27-.37c0-1.8-1.86-3.15-1.87-3.17a.38.38,0,0,1-.09-.54.39.39,0,0,1,.54-.09c.09.07,2.21,1.61,2.2,3.8a.39.39,0,0,1-.39.39Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "240.533px 154.05px"
    },
    id: "els2rgvexsgja",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,148.65a.39.39,0,0,1,0-.75,3.81,3.81,0,0,1,3.44.84.37.37,0,0,1,0,.54.38.38,0,0,1-.55,0h0a3.06,3.06,0,0,0-2.73-.63A.44.44,0,0,1,231,148.65Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "232.637px 148.593px"
    },
    id: "elffgw87m56tb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.24,186.71c2.28-.48,4.72-1,7.06-1.6s4.71-1.19,7-1.89,4.59-1.45,6.81-2.27c1.12-.42,2.2-.87,3.27-1.33.55-.22,1-.49,1.58-.73l.78-.37.62-.35c.87-.52,1.87-1.22,2.84-1.9s2-1.42,2.93-2.18c2-1.48,3.92-3,5.88-4.55s3.93-3.07,5.88-4.64l5.93-4.61,2.82,3c-1.68,1.9-3.43,3.71-5.17,5.54s-3.54,3.6-5.35,5.37-3.65,3.51-5.56,5.22c-.95.86-1.93,1.7-2.93,2.54a37.84,37.84,0,0,1-3.25,2.51l-1,.63-.89.5c-.59.32-1.18.69-1.78,1l-1.8.9-1.81.81c-2.43,1.05-4.87,2-7.35,2.79s-4.95,1.55-7.45,2.19-5,1.21-7.63,1.66Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "278.94px 177.62px"
    },
    id: "eltlxut5aoj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.68,207.51c9-3.49,13.25-6.37,13.25-6.37l-.66-21.63S250,181.42,244,186.18C240.28,189.11,244,208.94,247.68,207.51Z",
    style: {
      fill: "current",
      transformOrigin: "251.694px 193.547px"
    },
    id: "elap6b7marvti",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el6xwv8py6h3d"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "251.694px 193.547px"
    },
    className: "animable",
    id: "ell17uez5hbfk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.68,207.51c9-3.49,13.25-6.37,13.25-6.37l-.66-21.63S250,181.42,244,186.18C240.28,189.11,244,208.94,247.68,207.51Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "251.694px 193.547px"
    },
    id: "elsqbx1rzwi1e",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M229.17,190.63s3.92.25,4,5.29c5.23-2,12.83-7.84,13.87-12.36a1.25,1.25,0,0,0-1-1.52c-.44-.07-.85-.12-1.14-.15a1.23,1.23,0,0,0-.77.18l-6.29,3.84Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "238.122px 188.902px"
    },
    id: "eladesrlu2bjg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.69,185l1.55-4.86-2.08-1c-2.64,1.46-6,12-2.14,15.79,2.12-5,5.15-4.33,5.15-4.33Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "225.721px 187.035px"
    },
    id: "ellul5eg9wum",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.07,181.86a103.74,103.74,0,0,0-15-1.34h-1c-1.4,2.17-2.13,6,1.06,10.81,0,0,13-3.91,16.94-9.17C244.39,182.05,243.73,182,243.07,181.86Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "235.473px 185.925px"
    },
    id: "elhj5uq2njafm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.37,383.43a3.09,3.09,0,0,1-1.89.8,1.06,1.06,0,0,1-.85-.54.64.64,0,0,1,0-.61c.47-1.05,4.08-1.69,4.48-1.76a.21.21,0,0,1,.21.1.18.18,0,0,1,0,.22A14.06,14.06,0,0,1,231.37,383.43Zm-2.19-.47a.71.71,0,0,0-.25.28.23.23,0,0,0,0,.24.7.7,0,0,0,.55.36c.67.06,1.79-.69,3.05-2A10.54,10.54,0,0,0,229.18,383Z",
    style: {
      fill: "current",
      transformOrigin: "230.955px 382.774px"
    },
    id: "eldt87x1097j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.21,381.67a.15.15,0,0,1-.07,0c-1,.24-3.65,0-4.09-.83-.1-.2-.14-.51.25-.88a1.41,1.41,0,0,1,1.06-.38c1.34.06,2.82,1.7,2.88,1.77a.19.19,0,0,1,0,.19A.17.17,0,0,1,233.21,381.67Zm-3.55-1.47-.09.08c-.26.24-.2.36-.18.41.27.49,2.15.81,3.31.69a4.54,4.54,0,0,0-2.36-1.38A1,1,0,0,0,229.66,380.2Z",
    style: {
      fill: "current",
      transformOrigin: "231.124px 380.668px"
    },
    id: "el03bovszumuqi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.58,155.63l-1.21-1.13S237.53,156,238.58,155.63Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "237.975px 155.094px"
    },
    id: "el070r52icw974",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.36,232l.58,3c.1.24-.2.45-.58.42l-34.09-3c-.3,0-.53-.2-.53-.38l0-3c0-.2.27-.35.6-.32l33.54,3A.6.6,0,0,1,247.36,232Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "230.35px 232.07px"
    },
    id: "elj6phqguc7ir",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.52,235.34l.9.08c.18,0,.32-.06.32-.18l-.08-3.89c0-.11-.15-.22-.33-.23l-.9-.08c-.18,0-.32.06-.32.18l.08,3.89C242.19,235.22,242.34,235.33,242.52,235.34Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "242.925px 233.23px"
    },
    id: "eldt2xs5lop0p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.77,233l.9.08c.18,0,.32-.07.32-.18l-.08-3.89c0-.12-.15-.22-.33-.24l-.9-.08c-.18,0-.32.07-.32.18l.08,3.89C215.44,232.83,215.59,232.94,215.77,233Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "216.175px 230.885px"
    },
    id: "elgdbm5imbs85",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.14,234.15l.9.08c.18,0,.33-.07.32-.18l-.08-3.89c0-.11-.15-.22-.32-.23l-.9-.08c-.18,0-.33.06-.32.17l.07,3.89C228.82,234,229,234.13,229.14,234.15Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "229.55px 232.04px"
    },
    id: "elbv6lh6z9je",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.85,161.73l-.09-8.84,6.42,5.3s-1,5.16-4.22,6.19Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "304.97px 158.635px"
    },
    id: "el58s6jx4oie",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.95 147.42 311.08 152.15 308.18 158.19 301.76 152.89 305.95 147.42",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "306.42px 152.805px"
    },
    id: "elwosd2az8wk",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-67"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.82,346.89,137.35,324.27a12.09,12.09,0,0,1-10.52-13.41l23.91-198.11a12.09,12.09,0,0,1,13.41-10.52l187.47,22.63a12.08,12.08,0,0,1,10.52,13.41l-23.91,198.1A12.08,12.08,0,0,1,324.82,346.89Z",
    style: {
      fill: "none"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitHistory);
export default __webpack_public_path__ + "static/media/visitHistory.e6d3059d.svg";
export { ForwardRef as ReactComponent };